import { Col, Row } from "react-bootstrap";
import clsx from "clsx";
import * as eDepositSelectors from "../../../../selectors/e-deposit";
import CustomEmptyFont from "../../../../components/CustomEmptyFont";

function DepositManualPaymentItem({ item, index, onClickViewDocument }) {
  const type = eDepositSelectors.getManualPaymentTypeText(item);
  const amount = eDepositSelectors.getManualPaymentAmountText(item);
  const status = eDepositSelectors.getManualPaymentStatusText(item);
  const bankName = eDepositSelectors.getManualPaymentDraweeBankName(item);
  const bankTransactionDate = eDepositSelectors.getManualPaymentBankTransactionDateValue(item);
  const chequeNo = eDepositSelectors.getManualPaymentChequeNo(item);
  const companyBankName = eDepositSelectors.getManualPaymentDepositCompanyBankName(item);
  const companyBankAccount = eDepositSelectors.getManualPaymentDepositCompanyBankAccount(item);
  const publicUrl = eDepositSelectors.getManualPaymentDocumentPublicUrl(item);

  return (
    <div>
      <div className="d-flex deposit-form-title position-relative">
        <p className="payment-detail-title text-bold-600 mb-0">Manual Payment Info {index + 1}</p>
      </div>
      <div className={clsx("deposit-item-container")}>
        <Row className={clsx("gy-3")}>
          <Col xl={4} md={6} xs={12}>
            <h6>Type</h6>
            <p>{type}</p>
          </Col>
          <Col xl={4} md={6} xs={12}>
            <h6>Amount</h6>
            <p>{amount}</p>
          </Col>
          <Col xl={4} md={6} xs={12}>
            <h6>Status</h6>
            <p>{status}</p>
          </Col>
          <Col xl={4} md={6} xs={12}>
            <h6>Drawee Bank (Client)</h6>
            <CustomEmptyFont value={bankName} />
          </Col>
          <Col xl={4} md={6} xs={12}>
            <h6>Bank Date</h6>
            <CustomEmptyFont value={bankTransactionDate} />
          </Col>
          <Col xl={4} md={6} xs={12}>
            <h6>Cheque No</h6>
            <CustomEmptyFont value={chequeNo} />
          </Col>
          <Col xl={4} md={6} xs={12}>
            <h6>Deposit Bank (TA)</h6>
            <CustomEmptyFont value={companyBankName} />
          </Col>
          <Col xl={4} md={6} xs={12}>
            <h6>Deposit Bank Account</h6>
            <CustomEmptyFont value={companyBankAccount} />
          </Col>
        </Row>
        <Row className={clsx("gy-3 mt-2")}>
          <div><button
            className={clsx("btn custom-button-primary")}
            style={{ backgroundColor: "#9D7905" }}
            onClick={(e) => {
              e.preventDefault();
              onClickViewDocument && onClickViewDocument(publicUrl);
            }}
          >
            View Attachment
          </button>
          </div>
        </Row>
      </div>
    </div>
  );
}
export default DepositManualPaymentItem;
